import { ApolloClient } from '@apollo/client'
import { InitApolloClient, InitApolloClientOptions } from '@src/lib/CustomSSR/withCustomSSR'

let _apolloClient: ApolloClient

export default function initApolloClient<TCache = any>(
  clientFn: InitApolloClient<TCache>,
  options?: InitApolloClientOptions<TCache>
): ApolloClient {
  if (!clientFn) {
    throw new Error('[withApollo] the first param is missing and is required to get the ApolloClient')
  }

  if (typeof window === 'undefined') {
    return getClient(clientFn, options)
  }

  if (!_apolloClient) {
    _apolloClient = getClient(clientFn, options)
  }

  return _apolloClient
}

function getClient(clientFn: InitApolloClient, options: InitApolloClientOptions = {}): ApolloClient {
  if (typeof clientFn !== 'function') {
    throw new Error('[withApollo] requires a function that returns an ApolloClient')
  }

  return clientFn(options)
}
